import { tWithKeyAttr as t } from "../../i18nHelper";
import React from "react";
import styles from "./riskAlertCard.module.css";
import { RiskAlertServerResponse } from "../../services/api/riskAlerts.api";

interface RiskAlertCardProps {
  alert: RiskAlertServerResponse;
  onView: () => void;
  isDeleting?: boolean; 
}

const RiskAlertCard: React.FC<RiskAlertCardProps> = ({
  alert,
  onView,
  isDeleting = false,
}) => {
  const getRiskColor = (level: string) => {
    switch (level) {
      case "Red":
        return styles.high;
      case "Orange":
        return styles.medium;
      case "Green":
        return styles.low;
      default:
        return "";
    }
  };


  // --- Date/Time calculation logic moved here ---
  const alertDate = new Date(alert.updatedAt);
  
  const today = new Date();
  const alertDay = new Date(
    alertDate.getFullYear(),
    alertDate.getMonth(),
    alertDate.getDate()
  );
  const todayDay = new Date(
    today.getFullYear(),
    today.getMonth(),
    today.getDate()
  );
  const diffTime = todayDay.getTime() - alertDay.getTime();
  const diffDays = diffTime / (1000 * 60 * 60 * 24);

  let dateDisplay: string;
  if (isNaN(diffDays)) {
    dateDisplay = alert.updatedAt; // Fallback to raw date string
  } else if (diffDays === 0) {
    dateDisplay = t('TODAY');
  } else if (diffDays === 1) {
    dateDisplay = t('YESTERDAY');
  } else {
    const day = alertDate.getDate();
    const month = alertDate.toLocaleString("en-US", { month: "short" });
    dateDisplay = `${month} ${day}`;
  }

  const timeDisplay = alertDate.toLocaleTimeString('he-IL', { 
    hour: '2-digit', 
    minute: '2-digit',
    hour12: false 
  });

  let methodMinutesAgo: string | null = null;
  if (diffDays === 0 && !isNaN(alertDate.getTime())) {
    const now = new Date();
    const diffMs = now.getTime() - alertDate.getTime();
    const diffMin = Math.floor(diffMs / (1000 * 60));
    if (diffMin >= 0 && !isNaN(diffMin)) {
      methodMinutesAgo = ` · ${diffMin} ${t('MINUTES_AGO')}`;
    }
  }

  return (
    <div
      className={`${styles.card} ${getRiskColor(alert.riskLevel)} ${
        isDeleting ? styles.deleting : ""
      }`}
    >
      <div className={styles.cardGlow}></div>
      <div className={styles.info}>
        <div className={`${styles.icon} ${getRiskColor(alert.riskLevel)}`}>
          <span className={styles.iconText}>!</span>
          <div className={styles.iconPulse}></div>
        </div>
        <div className={styles.details}>
          <div className={styles.name}>
            {alert.patientFullName || t('NO_NAME_AVAILABLE')}{alert.age ? `, ${alert.age}` : ''}
          </div>
          <div className={styles.riskBadge}>
            <span className={styles.riskDot}></span>
            <span className={`${styles.risk} ${getRiskColor(alert.riskLevel)}`}>
              {alert.riskLabel}</span>
          </div>
        </div>
      </div>
      <div className={styles.actionRow}>
        <div className={styles.date}>
          <span className={styles.dateIcon}>📅</span>
          {dateDisplay} · {timeDisplay}
        </div>
        <div dir="ltr" className={styles.method}>
          <span className={styles.methodIcon}>📊</span>
          {alert.sourceName}
        </div>
        <button className={styles.viewBtn} onClick={onView}>
          <span>{t('WATCHING')}</span>
          <span className={styles.btnArrow}>←</span>
        </button>
      </div>
    </div>
  );
};

export default RiskAlertCard;
